/**
 * @file Global web gallery fragments.
 */

import gql from 'graphql-tag';

export const PhotoUrlTypeFields = gql`
  fragment PhotoUrlTypeFields on PhotoURLType {
    url
    width
    height
    size_code
  }
`;

export const PhotoAttribution = gql`
  fragment PhotoAttribution on Photo {
    attribution {
      name
      username
      organization_name
      avatar_photo {
        id
        thumbnail_urls {
          ...PhotoUrlTypeFields
        }
      }
      account_id
      photo_attribution_page {
        is_enabled
      }
    }
  }
`;
